"use client";
/* global BigInt */
import { useEffect, useState } from "react";
import {
  Box,
  IconButton,
  useBreakpointValue,
  Stack,
  Heading,
  Text,
  Container,
  Flex,
  HStack,
  Spinner,
  useDisclosure,
  Button,
  VStack,
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalFooter,
  ModalBody,
  List,
  ListItem,
  Select,
  Link,
  Center,
  OrderedList,
} from "@chakra-ui/react";
// Here we have used react-icons package for the icons
import { BiLeftArrowAlt, BiRightArrowAlt } from "react-icons/bi";
// And react-slick as our Carousel Lib
import Slider from "react-slick";

import {
  EthereumChains,
  MnemonicBackupMethod,
  SetupWizardState,
  Web3StorageAccessMethod,
  SignalInitStep,
  PlexiMailStatus,
  StorageProvider,
} from "../utils/Types";
import { ClientError, showError } from "../common/errors";
import Strings from "../config/Strings";
import {
  BACKUP_FOLDER,
  RECOVER_WEB3_CONFIG_AUTOMATICALLY,
  CONFIG_PLEXIMAIL_AUTOMATICALLY,
  mailAddressDomain,
  DEPRECATED_PASSWORD,
  isSupportedBrowser,
  isUnsupportedBrowser,
  SIMPLE_INITIALIZATION_MODE,
  isMobile,
  HELP_DOC_URL,
} from "../common/constants";
import InitializationFailedAlert from "./InitializationFailedAlert";
import InternetIdentityAuthAlert from "./InternetIdentityAuthAlert";
import { ReactComponent as ICPIcon } from "./icp.svg";
import { useAuth } from "../icp/authContext";
import AFWallet from "../wallet/AFWalletV2";
import { ethers, hexlify } from "ethers";
import { IdbKeyVal } from '@dfinity/auth-client/lib/cjs/db.js'; // 导入 IdbStorage

import {DelegationIdentity, Ed25519PublicKey, ECDSAKeyIdentity, Ed25519KeyIdentity, DelegationChain} from "@dfinity/identity";

// Settings for the slider
const settings = {
  dots: true,
  arrows: false,
  fade: true,
  infinite: true,
  autoplay: true,
  speed: 500,
  autoplaySpeed: 5000,
  slidesToShow: 1,
  slidesToScroll: 1,
  pauseOnHover: false,
};

function UnsupportedModal({ disclosure }) {
  return (
    <Modal
      size={"full"}
      isOpen={disclosure.isOpen}
      onClose={disclosure.onClose}
      closeOnOverlayClick={false}
    >
      <ModalOverlay />
      <ModalContent>
        <ModalHeader>{Strings.home.dialog.unsupported.title}</ModalHeader>
        {/* <ModalCloseButton /> */}

        <ModalBody>
          <Text>{Strings.home.dialog.unsupported.content.paragraph1}</Text>
          <List pl={"20px"}>
            {isMobile && (
              <>
                <ListItem fontWeight={"bold"}>
                  {Strings.home.dialog.unsupported.content.paragraph2}
                </ListItem>
                <ListItem fontWeight={"bold"}>
                  {Strings.home.dialog.unsupported.content.paragraph6 ||
                    "MetaMask Browser"}
                </ListItem>
              </>
            )}

            {!isMobile && (
              <>
                <ListItem fontWeight={"bold"}>
                  {Strings.home.dialog.unsupported.content.paragraph2}
                </ListItem>
                <ListItem>
                  {Strings.home.dialog.unsupported.content.paragraph3}
                </ListItem>
                <ListItem>
                  {Strings.home.dialog.unsupported.content.paragraph4}
                </ListItem>
                <ListItem>
                  {Strings.home.dialog.unsupported.content.paragraph5}
                </ListItem>
              </>
            )}
          </List>
        </ModalBody>

        {/* <ModalFooter>
      <Button colorScheme='green' onClick={() => {
        window.open('https://metamask.io/', '_blank')
        //window.location.href = ('https://metamask.io/');
      }}>Download &amp; Install</Button>
  </ModalFooter> */}
      </ModalContent>
    </Modal>
  );
}

const HomeScreenAction = {
  None: 0,
  Enter: 1,
  Continue: 2,
  Resume: 3,
  OneClickResume: 4,
};
export default function InitializationCarouselScreen({
  setAccounts,
  setSelectedAccount,
  selectedAccount,
  setSetupWizardState,
}) {
  const [slider, setSlider] = useState(null);

  const detectLanguage = () => {
    const lang = navigator.language;
    // console.log("detectLanguage:", lang);
    if (lang.startsWith("zh")) {
      return "zh";
    } else if (lang.startsWith("en")) {
      return "en";
    } else if (lang.startsWith("es")) {
      return "es";
    } else {
      return "en";
    }
  };

  let lang = localStorage.getItem("language");
  if (!lang || lang === "") {
    lang = detectLanguage();
  }

  if (lang !== "en" && lang !== "zh" && lang !== "es") {
    lang = "en";
  }
  const appType = localStorage.getItem("app.default.app") === "0" ? 0 : 1;

  const [language, setLanguage] = useState(lang || "en");


  var [chainId, setChianId] = useState(
    window.appConfig ? window.appConfig.chainId : EthereumChains.Goerli
  );
  const [isInitializing, setInitializing] = useState(false);
  const [isAlreadyBackup, setAlreadyBackup] = useState(false);
  const [isSettingUp, setIsSettingUp] = useState(false);

  const [aifiWalletIsDefaultWallet, setAifiWalletIsDefaultWallet] = useState(
    window.wallet.asDefaultWallet
  );
  const [activatedWallet, setActivatedWallet] = useState(null);
  const welcomeDisclosure = useDisclosure();
  const walletNotFoundDisclosure = useDisclosure();
  const [action, setAction] = useState(HomeScreenAction.None);


  const [createSpaceStep, setCreateSpaceStep] = useState(1);
  const [message, setMessage] = useState(null);
  const [error, setError] = useState(null);
  const failedDisclosure = useDisclosure();
  const {isAuthenticated, login, checkAuth, handleIIDelegation } = useAuth();


  const top = useBreakpointValue({ base: "90%", md: "50%" });
  const side = useBreakpointValue({ base: "30%", md: "40px" });
  const email = "w3up-shared-storage@ai-fi.cc";
  const cards = Strings.setup_carousel.cards;
  const intros = Strings.setup_carousel.intros;

  let connecting = false;

  useEffect(() => {
    initial().then(() => {
      console.log("initialization completed");
      if (localStorage.getItem('authorized-client-success') === '1') {
        localStorage.removeItem('authorized-client-success');
        setMessage('Authorized successfully');
        continueFromIOS().then(() => {
          console.log('error');
        });
        /*
        connectClicked().then(() => {
          console.log('error');
        });
        */
      }
    }).catch(e => {
      console.log(e);
      showError(e);
    })
  }, []);


  const icpAuthDisclosure = useDisclosure();
  const [icpAuthTask, setIcpAuthTask] = useState(null);
  const showIcpAuthIntroIfNeeded = async () => {
    const task = {}
    const promise = new Promise((resolve, reject) => {
      task.resolve = resolve;
      task.reject = reject;
    })
    task.promise = promise;

    setIcpAuthTask(task);

    icpAuthDisclosure.onOpen();
    const allowed = await promise;
    return allowed;
  }
  const handleIOSIIDelegation = async (urlStr) => {
    const url = new URL(urlStr);
    const params = url.searchParams;
    // const params = new URLSearchParams(window.location.search);
    const data = params.get('data');
    if (!data) {
      window.location.href = `plexisignapp://ii-callback?error=${encodeURIComponent('Missing data')}`;
      return;
    }
    const response = JSON.parse(data);
    if (!response.delegations || response.delegations.length === 0) {
      window.location.href = `plexisignapp://ii-callback?error=${encodeURIComponent('Missing delegations')}`;
      return;
    }

    const delegations = response.delegations.map(d => {
      return {
        delegation: {
          pubkey: Uint8Array.fromHex(d.delegation.pubkey),
          expiration: BigInt(d.delegation.expiration),
          targets: undefined,
        },
        signature: Uint8Array.fromHex(d.signature),
      };
    });
    const userPublicKey = Uint8Array.fromHex(response.userPublicKeyHex);
    const message = {
      delegations,
      userPublicKey
    };
    await handleIIDelegation(message);
    localStorage.setItem('authorized-client-success', '1');
    window.location.reload();
  }

  const initial = async () => {
    
    if (window.wallet) {
      setAifiWalletIsDefaultWallet(window.wallet.asDefaultWallet);
    }
    try {

      /*
      if (window.location.href.indexOf("authorize-client-success") !== -1) {
        const isAuthenticated = await checkAuth();
        if (!isAuthenticated) {
          const params = new URLSearchParams(window.location.search);
          const data = params.get('data');
          if (!data) {
            window.location.href = `plexisignapp://ii-callback?error=${encodeURIComponent('Missing data')}`;
            return;
          }
          const response = JSON.parse(data);
          if (!response.delegations || response.delegations.length === 0) {
            window.location.href = `plexisignapp://ii-callback?error=${encodeURIComponent('Missing delegations')}`;
            return;
          }

          const delegations = response.delegations.map(d => {
            return {
              delegation: {
                pubkey: Uint8Array.fromHex(d.delegation.pubkey),
                expiration: BigInt(d.delegation.expiration),
                targets: undefined,
              },
              signature: Uint8Array.fromHex(d.signature),
            };
          });
          const userPublicKey = Uint8Array.fromHex(response.userPublicKeyHex);
          const message = {
            delegations,
            userPublicKey
          };

          console.log("auth:", message);
          await handleIIDelegation(message);
          await continueFromIOS();
        }
      }*/

      const isAuthenticated = await checkAuth();
      console.log("isAuthenticated:", isAuthenticated);
      // if (!isAuthenticated &&
      //   window.appConfig.setupWizardState === SetupWizardState.Completed) {
      //   try {
      //     // await login();
      //     await icpLogin();
      //     await waitPlexiMailServiceReady();
      //   } catch (e) {
      //     setInitializing(false);
      //     if ("UserInterrupt" !== e) {
      //       showError(e);
      //     }
      //     console.error(e);
      //     return;
      //   }
      // }

    } catch (e) {
      console.log(e);
      showError(e);
    }

    if (window.appConfig.setupWizardState !== SetupWizardState.Completed) {
      if (!window.web3Helper) {
          console.log('[DBG] InitializationCarouselScreen web3Helper undefined ')
        if (window.initialNetwork) {
          window.initialNetwork(window.chainId);
          console.log('[DBG] InitializationCarouselScreen initialNetwork ')
        } else {
          console.log('[DBG] InitializationCarouselScreen initialNetwork undefined ')
        }
      }
      try {
        if (window.web3Helper && window.web3Helper.ethereum) {
        } else {
          if (isUnsupportedBrowser) {
            const type = window.wallet.rpcProviderType();
            if (type === AFWallet.RPCProviderType.Other) {
              welcomeDisclosure.onOpen();
            }
          } else {
            const type = window.wallet.rpcProviderType();
            if (type === AFWallet.RPCProviderType.Other) {
              if (window.appConfig.isNewUser) {
                welcomeDisclosure.onOpen();
              } else {
                walletNotFoundDisclosure.onOpen();
              }
            }
          }
        }
      } catch(e) {
        console.error(e)
      }
    }

    

    const isBackup = await window.wallet.isBackup();
    setAlreadyBackup(isBackup);
    console.log("isAlreadyBackup:", isBackup);
    const activatedWallet = await window.wallet.getActivatedWallet();

    if (
      !activatedWallet ||
      activatedWallet.address.toLowerCase() !==
        window.appConfig.recentActiveAccount
    ) {
      console.warn("Activated Wallet not match pleximail recent account");
      // connectClicked();
      // continueFromIOS();
      return;
    }

    const hasMultipleAccounts = await window.wallet.hasMultipleAccounts();

    if (
      !hasMultipleAccounts &&
      window.appConfig.setupWizardState === SetupWizardState.Completed
    ) {

      // if (SIMPLE_INITIALIZATION_MODE && localStorage.getItem('initialization.mode') === 'simple') {
      if (SIMPLE_INITIALIZATION_MODE) {
        unlockClicked(DEPRECATED_PASSWORD, true);
        return;
      }


      const cfg = new URL(window.location.href).searchParams.get("cfg");
      try {
        const buf = ethers.decodeBase64(cfg);
        if (buf && buf.length > 0) {
          const str = new TextDecoder().decode(buf);
          if (str && str.length > 0) {
            const obj = JSON.parse(str);
            if (obj && obj.pin && obj.pin.length > 0) {
              unlockClicked(obj.pin, true);
            }
          }
        }
      } catch (e) {}
    }

  }

  const reset = () => {
    window.mailService
      .reset()
      .then(() => {
        return window.wallet.reset();
      })
      .then(() => {
        window.appConfig.setupWizardState = SetupWizardState.ConnectWallet;
        window.forceQuit = true;
        setTimeout(function () {
          window.location.reload(true);
        });
      })
      .catch((e) => {
        console.error(e);
        showError(e);
      });
  };

  async function getNonce(account) {
    const nonce = await window.mailService.getNonce(account);
    return nonce;
  }

  async function authenticate(account) {
    const message = await getNonce(account);
    const pwd =
      window.wallet && window.wallet.asDefaultWallet
        ? "--sign-the-message-silently--"
        : "";
    const web3 = window.web3Helper.web3;
    const signatureHex = await web3.eth.personal.sign(message, account, pwd);
    const recoveredAddr = window.web3Helper.ecRecover({
      data: message,
      signature: signatureHex,
    });
    if (recoveredAddr.toLowerCase() === account) {
      window.appConfig.pushApiToken = await window.mailService.login({
        account: account,
        signature: signatureHex,
      });
    } else {
      throw ClientError.invalidParameterError(
        Strings.error.client.invalid_signature
      );
    }
  }

  async function prepareToken(account) {
    try {
      await window.mailService.checkToken(window.appConfig.pushApiToken);
    } catch (e) {
      console.error(e);
      await authenticate(account);
    }
  }

  const icpLogin = async () => {
    // 检测是否在 iOS app 中（简单检测，可用自定义 UA 或 storage 标志）
    // const isIOSApp = true; 
    let isIOSApp = /PlexiSignApp/.test(navigator.userAgent) && !window.MSStream;
    if (!isIOSApp) {
      const u = new URL(window.location.href);
      isIOSApp = u.searchParams.get('platform') === 'ios';
    }
    
    if (isIOSApp) {

        const storage = await IdbKeyVal.create();
        const kp = await storage.get('identity');
        const sessionKey = kp ?  await ECDSAKeyIdentity.fromKeyPair(kp) : await ECDSAKeyIdentity.generate();

        // 生成 session key
        // Ed25519KeyIdentity.generate()
        // const sessionKey = Ed25519KeyIdentity.generate();
        // const sessionKey = await ECDSAKeyIdentity.generate();

        // 临时存储 sessionKey JSON (仅本次使用，完成后移除)
        // sessionStorage.setItem('tempSessionKey', JSON.stringify(sessionKey.toJSON()));
        if (!kp) {
          await storage.set('identity', sessionKey.getKeyPair());
        }

        // sessionStorage.setItem('tempSessionKey', sessionKey.getKeyPair());
        const kp1 = await storage.get('identity');
        const sessionKey1 = await ECDSAKeyIdentity.fromKeyPair(kp1);
        console.log(sessionKey1);

        // 获取 publicKey DER hex
        const publicKeyDer = sessionKey.getPublicKey().toDer();
        const publicKeyBuffer = new Uint8Array(publicKeyDer);//.map(b => b.toString(16).padStart(2, '0')).join('');

        // const publicKeyHex = Buffer.from(publicKeyBuffer.buffer, publicKeyBuffer.byteOffset, publicKeyBuffer.byteLength).toString('hex');
        const publicKeyHex = publicKeyBuffer.toHex();// hexlify(publicKeyBuffer);
        // const publicKeyHex = Array.from(publicKeyDer).map(b => b.toString(16).padStart(2, '0')).join('');

        // iOS 模式：导航到自定义 URL，传递参数给 bridge
        let identityProvider = localStorage.getItem('app.ii.url');
        if (!identityProvider || identityProvider.length === 0) {
          identityProvider = process.env.DFX_NETWORK === 'ic'
          ? 'https://identity.ic0.app/#authorize'
          : `http://${process.env.CANISTER_ID_INTERNET_IDENTITY}.localhost:4943/#authorize`; 
        }
        if (process.env.DFX_NETWORK === 'ic') {
          // identityProvider = "https://7uvlp-gyaaa-aaaak-apbtq-cai.icp0.io/#authorize";
          identityProvider = "https://id.ai/#authorize";
        }

        const maxTimeToLive = BigInt(196) * BigInt('3600000000000')
        // const maxTimeToLive = 3600000000000; // 1 小时 (ns)
        const derivationOrigin = window.location.origin;

        const params = new URLSearchParams({
            publicKeyHex,
            identityProvider,
            maxTimeToLive: maxTimeToLive.toString(),
            derivationOrigin
        }).toString();

        // if (!window.handleIIDelegation) {
        //   // 处理从 app 注入的 delegation，并存储到 IndexedDB (模拟 auth-client)
        //   window.handleIIDelegation = handleIIDelegation;
        // }

        window.handleIIDelegation = handleIOSIIDelegation;
        console.log(`params: ${params}`)
        // 导航到自定义 scheme URL（app 会拦截）
        window.location.href = `plexisignapp://bridge?${params}`;
        // window.location.href = `/?action=ii-auth-bridge&${params}`;
        // window.location.href = `/bridge.html?${params}`;
        const promise = new Promise((resolve, reject) => {
          // window.handleIIDelegation = (delegation) => {
          //   resolve(delegation);
          // };
          // just pending here, wait for delegation from app
        });
        await promise;
    } else {
      await login();
    }
  };


  async function unlock(pinCode) {
    try {
      const password = DEPRECATED_PASSWORD;
      await window.mailService.verifyPassword(password);

      window.appConfig.masterKey = password;
    } catch (e) {
      console.error(e);
      throw ClientError.invalidParameterError(
        Strings.common.message.incorrect_password
      );
    }
  }

  async function createWalletSilently() {
    try {
      setInitializing(true);
      await window.wallet.createWalletSilently();
    } catch (e) {
      throw e;
    } finally {
      setInitializing(false);
    }
  }
  async function changeNetwork(newChainId) {
    //
    if (newChainId === chainId) {
      return;
    }

    setChianId(newChainId);
    window.chainId = newChainId;

    if (newChainId === EthereumChains.Goerli) {
      window.web3Helper.init("goerli");
    } else if (newChainId === EthereumChains.Mainnet) {
      window.web3Helper.init("mainnet");
    } else if (newChainId === EthereumChains.Fuji) {
      window.web3Helper.init("fuji");
    } else if (newChainId === EthereumChains.Avalanche) {
      window.web3Helper.init("mainnet");
    } else if (newChainId === EthereumChains.Sepolia) {
      // window.web3Helper.init('sepolia');

      const sepOpts = {
        // rpcUrl: 'https://rpc.sepolia.org', // your ethereum, polygon, or optimism mainnet/testnet rpc URL
        // rpcUrl: 'https://polygon-mumbai-infura.wallet.coinbase.com?targetName=ethereum-sepolia',
        rpcUrl:
          "https://eth-sepolia.g.alchemy.com/v2/tApGyKU4AgHcem9l6xFsuMCdVe6mah6P",
        // rpcUrl: 'https://sepolia.rpc.thirdweb.com',
        chainId: 11155111,
      };
      window.web3Helper.init(sepOpts);
    } else {
      window.web3Helper.init("fuji");
    }
  }

  async function waitPlexiMailServiceReady() {
    while (
      typeof window.plexiMailService === "undefined" ||
      window.plexiMailService === null
    ) {
      const promise = new Promise((resolve, reject) => {
        setTimeout(() => {
          resolve();
        }, 100);
      });
      await promise;
    }
  }

  async function connectWallet() {
    if (!window.web3Helper || !window.web3Helper.ethereum) {
      connecting = false;
      setInitializing(false);
      return;
    }

    try {
      connecting = true;
      setInitializing(true);
      if (window.appConfig.chainId && window.appConfig.chainId.length >= 0) {
        if (window.appConfig.recentChainId !== window.appConfig.chainId) {
          window.appConfig.recentChainId = window.appConfig.chainId;
        }
      } else {
        if (
          window.appConfig.recentChainId &&
          window.appConfig.recentChainId.length > 0
        ) {
          window.appConfig.chainId = window.appConfig.recentChainId;
        }
      }

      console.log("HomeScreen - connectWallet");
      let accounts = null;
      let rpcProviderType = window.wallet.rpcProviderType();
      if (rpcProviderType === AFWallet.RPCProviderType.Unset) {
        rpcProviderType = await window.wallet.changeRpcProviderType();
      }
      if (rpcProviderType === AFWallet.RPCProviderType.AFWallet) {
        accounts = await window.web3Helper.web3.eth.requestAccounts();
      } else {
        accounts = await window.web3Helper.web3.eth.requestAccounts();
      }

      const selectedAddress =
        accounts.length > 0 ? accounts[0].toLowerCase() : "";
      if (!selectedAddress || selectedAddress.length === 0) {
        throw ClientError.invalidParameterError("No account in your wallet");
      }

      window.appConfig.recentActiveAccount = selectedAddress;
      window.appConfig.migrateIfNeeded(selectedAddress);

      if (window.appConfig.recentChainId !== window.appConfig.chainId) {
        window.appConfig.chainId = window.appConfig.recentChainId;
        await changeNetwork(window.appConfig.recentChainId);
      }

      if (
        window.appConfig.tempMasterKey &&
        window.appConfig.tempMasterKey.length > 0 &&
        (!window.appConfig.masterKey || window.appConfig.masterKey === "")
      ) {
        window.appConfig.masterKey = window.appConfig.tempMasterKey;
      }
      if (
        window.appConfig.tempMnemonic &&
        window.appConfig.tempMnemonic.length > 0 &&
        (!window.appConfig.mnemonic || window.appConfig.mnemonic === "")
      ) {
        window.appConfig.mnemonic = window.appConfig.tempMnemonic;
      }

      const accountIndex = window.appConfig.assignAccountIndex(selectedAddress);
      window.mailService.selectedAccountIndex = accountIndex;
      window.mailService.selectedAccount = selectedAddress;

      if (window.appConfig.isPushApiTokenConfigured) {
        await prepareToken(selectedAddress);
      } else {
        await authenticate(selectedAddress);
      }

      setAccounts(accounts);
      setSelectedAccount(selectedAddress);

      connecting = false;
      // setInitializing(false);

      // trigger state machine
      if (
        window.appConfig.setupWizardState === SetupWizardState.ConnectWallet
      ) {
        if (window.wallet.asDefaultWallet) {
          if (
            window.appConfig.plexiMailStatus === PlexiMailStatus.WaitForNew ||
            window.appConfig.plexiMailStatus ===
              PlexiMailStatus.WaitForOneClickNew
          ) {
            await window.mailService.initCryptServiceIfNeeded();
            window.appConfig.tempMnemonic = window.appConfig.mnemonic;
            window.appConfig.setupWizardState =
              SetupWizardState.ConfigWeb3Storage;
            setSetupWizardState(SetupWizardState.ConfigWeb3Storage);
          } else if (
            window.appConfig.plexiMailStatus ===
              PlexiMailStatus.WaitForRecovery ||
            window.appConfig.plexiMailStatus ===
              PlexiMailStatus.WaitForOneClickRecovery
          ) {
            window.appConfig.setupWizardState =
              SetupWizardState.SelectSetupMethod;
            setSetupWizardState(SetupWizardState.SelectSetupMethod);
          } else {
            window.appConfig.setupWizardState =
              SetupWizardState.SelectSetupMethod;
            setSetupWizardState(SetupWizardState.SelectSetupMethod);
          }
        } else {
          window.appConfig.setupWizardState =
            SetupWizardState.SelectSetupMethod;
          setSetupWizardState(SetupWizardState.SelectSetupMethod);
        }
      } else {
        if (
          SetupWizardState.ConfigSignal === window.appConfig.setupWizardState ||
          SetupWizardState.ExportConfig === window.appConfig.setupWizardState ||
          SetupWizardState.WaitForTransactionReceipt ===
            window.appConfig.setupWizardState ||
          SetupWizardState.Completed === window.appConfig.setupWizardState
        ) {
          await window.mailService.initFoldersIfNeeded(false, false);
        }

        setSetupWizardState(window.appConfig.setupWizardState);
        if (window.appConfig.setupWizardState === SetupWizardState.Completed) {
          window.isUnlocked = true;
        }
      }
    } catch (e) {
      console.error("failed to login: ", e);
      if (e.code === -32002) {
        connecting = false;
        // setInitializing(false);
        showError(Strings.error.rpc[e.code + ""] || e.message);
        return;
      }
      connecting = false;
      // setInitializing(false);
      showError(e);
    }
  }
  async function continueFromIOS() {
    delete window.isOneClickResume;

    const isAuthenticated = await checkAuth();
    if (!isAuthenticated) {
      return;
    }

    if (
      window.appConfig.setupWizardState === SetupWizardState.ConnectWallet
    ) {
      connecting = true;
      setInitializing(true);
      try {

        await waitPlexiMailServiceReady();

          
        const isRegistered = await window.plexiMailService.isRegistered();
        if (isRegistered) {
          setMessage(Strings.common.message.recover_wallet);
          setAction(HomeScreenAction.OneClickResume);
          window.isOneClickResume = true;
          await connectWallet();

          await initialPlexiMail();
          return;
        } else {
          const walletIsConfigured = window.wallet
            ? await window.wallet.isConfigured()
            : false;
          if (walletIsConfigured) {
            await connectWallet();
          } else {
            if (SIMPLE_INITIALIZATION_MODE) {
              localStorage.setItem("initialization.mode", "simple");
              await createWalletSilently();
              await connectWallet();
            } else {
              await connectWallet();
            }
          }

          await initialPlexiMail();
        }
      } catch (e) {
        if ("UserInterrupt" !== e) {
          showError(e);
        }
        console.error(e);
        setInitializing(false);
        return;
      } finally {
        connecting = false;
        // setInitializing(false);
      }
    }
  }
  async function connectClicked() {
    delete window.isOneClickResume;

    const isAuthenticated = await checkAuth();

    if (
      !isAuthenticated ||
      window.appConfig.setupWizardState === SetupWizardState.ConnectWallet
    ) {
      connecting = true;
      setInitializing(true);
      try {
        // await login();
        setMessage(Strings.common.message.sign_in_with_ii);
        await icpLogin();

        await waitPlexiMailServiceReady();

          
        const isRegistered = await window.plexiMailService.isRegistered();
        if (isRegistered) {
          setMessage(Strings.common.message.recover_wallet);
          setAction(HomeScreenAction.OneClickResume);
          window.isOneClickResume = true;
          await connectWallet();

          await initialPlexiMail();
          return;
        }
      } catch (e) {
        if ("UserInterrupt" !== e) {
          showError(e);
        }
        console.error(e);
        setInitializing(false);
        return;
      } finally {
        connecting = false;
        // setInitializing(false);
      }
    }

    const walletIsConfigured = window.wallet
      ? await window.wallet.isConfigured()
      : false;
    if (walletIsConfigured) {
      await connectWallet();
    } else {
      if (SIMPLE_INITIALIZATION_MODE) {
        localStorage.setItem("initialization.mode", "simple");
        await createWalletSilently();
        await connectWallet();
      } else {
        await connectWallet();
      }
    }

    await initialPlexiMail();
  }

  async function unlockClicked(pinCode = null, ignoreError = false) {
    try {
      // connecting = true;
      setInitializing(true);
      setMessage(Strings.common.message.sign_in_with_ii);
      const isAuthenticated = await checkAuth();
      if (!isAuthenticated) {
        try {
          // await login();
          const allowed  = await showIcpAuthIntroIfNeeded();
          if (!allowed) {
            setInitializing(false);
            return;
          }
          await icpLogin();
        } catch (e) {
          setInitializing(false);
          if ("UserInterrupt" !== e) {
            showError(e);
          }
          console.error(e);
          return;
        }
      }
      setMessage(Strings.common.message.prepare_env);
      await unlock(pinCode);
      connecting = false;
      setInitializing(false);
      if (window.web3Helper && window.web3Helper.ethereum) {
        if (
          !isInitializing &&
          !connecting &&
          window.appConfig.isPushApiTokenConfigured
        ) {
          await connectWallet();
        }
      }

      connecting = false;
      setInitializing(false);
    } catch (e) {
      console.error(e);

      setInitializing(false);
      if (!ignoreError) {
        showError(e);
      }
    }
  }

  async function assignStorage() {
    try {
      await window.mailService.web3StorageClient.assignStorage();
    } catch (err) {
      console.error(err);
      console.log("failed to register: ", err.message || err);
      throw err;
    }
  }

  async function setWeb3StorageProvider() {
    window.appConfig.storageProvider = StorageProvider.S3;
    window.appConfig.web3StorageAccessMethod = Web3StorageAccessMethod.Shared;
  }

  async function saveWeb3StorageConfig() {
    try {
      const isValidString = Boolean(email);
      if (!isValidString) {
        return;
      }

      window.appConfig.web3StorageApiToken = email;

      await window.mailService.initWeb3StorageClient(
        window.appConfig.web3StorageApiToken
      );
      // await window.mailService.initSignalService(selectedAccount);

      const res = await window.mailService.initFoldersIfNeeded(
        SetupWizardState.RestoreWeb3Storage ===
          window.appConfig.setupWizardState,
        false
      );
      console.log(res);

      if (window.wallet && window.wallet.asDefaultWallet) {
        //const saveLocally = (window.appConfig.mnemonicBackupMethod === MnemonicBackupMethod.LocalFile);
        //await window.mailService.saveCryptonToken(selectedAccount, window.appConfig.masterKey, "none", window.appConfig.web3StorageApiToken, true, saveLocally);
      } else {
        const saveLocally =
          window.appConfig.mnemonicBackupMethod ===
          MnemonicBackupMethod.LocalFile;
        await window.mailService.saveCryptonToken(
          selectedAccount,
          window.appConfig.masterKey,
          window.appConfig.mnemonic,
          window.appConfig.web3StorageApiToken,
          true,
          saveLocally
        );
      }
      window.appConfig.setupWizardState = SetupWizardState.ConfigSignal;
      // setSetupWizardState(SetupWizardState.Completed);
    } catch (e) {
      console.error(e);
      throw e;
    }
  }

  async function doRestoreWeb3StorageConfig() {
    await window.mailService.initWeb3StorageClient(
      window.appConfig.web3StorageApiToken
    );
    setMessage(Strings.common.message.retrieve_folder);
    const folders = await window.mailService.getFolders();

    setMessage(Strings.common.message.recover_signal);
    const backup = folders[BACKUP_FOLDER];
    Object.keys(backup.localStorage).forEach(function (key) {
      if (key.lastIndexOf("app.private-level") !== -1) {
        return;
      }
      if (!window.appConfig.privacyLevelIsNormal) {
        if (key.lastIndexOf(".app.setup-wizard-state") !== -1) {
          return;
        }
      }
      localStorage.setItem(key, backup.localStorage[key]);
    });

    if (!window.appConfig.privacyLevelIsNormal) {
      window.appConfig.setupWizardState =
        backup.localStorage[
          window.appConfig.recentActiveAccount + ".app.setup-wizard-state"
        ];
    }

    await window.mailService.importIndexedDB(backup.indexedDB);

    await window.mailService.initSignalService(selectedAccount || window.appConfig.recentActiveAccount);
    setMessage(Strings.common.message.completed_recovery);
    // window.appConfig.setupWizardState =
    //   SetupWizardState.Completed;
    // setSetupWizardState(SetupWizardState.Completed);

    await gotoMain();
  }

  async function restoreWeb3StorageConfig() {
    try {
      const isValidString = Boolean(email);
      if (!isValidString) {
        return;
      }
      if (window.mailService.isRecovering) {
        return;
      } else {
        window.mailService.isRecovering = true;
      }
      window.appConfig.web3StorageApiToken = email;

      await doRestoreWeb3StorageConfig();
      window.mailService.isRecovering = false;
    } catch (e) {
      window.mailService.isRecovering = false;
      console.error(e);
      throw e;
    }
  }

  async function configWeb3Storage() {
    if (
      SetupWizardState.ConfigWeb3Storage === window.appConfig.setupWizardState
    ) {
      await saveWeb3StorageConfig();
    } else if (
      SetupWizardState.RestoreWeb3Storage ===
        window.appConfig.setupWizardState ||
      SetupWizardState.SelectSetupMethod === window.appConfig.setupWizardState
    ) {
      await restoreWeb3StorageConfig();
    }
  }

  async function initialSignalContext() {
    const isInitialized = await window.mailService.signalIsInitialized(
      selectedAccount || window.appConfig.recentActiveAccount
    );
    if (isInitialized) {
      await window.mailService.resetSignalServiceFor(selectedAccount || window.appConfig.recentActiveAccount);
    }

    setMessage(Strings.common.message.sync_folders);
    await window.mailService.syncFoldersFile();

    await window.mailService.initSignalService(selectedAccount || window.appConfig.recentActiveAccount, (step) => {
      switch (step) {
        case SignalInitStep.CheckPreKeyCount:
          setMessage(Strings.common.message.supply_prekeys);
          break;
        case SignalInitStep.GenerateKeys:
          setMessage(Strings.common.message.generate_keys);
          break;
        case SignalInitStep.SavePreKeyBundle:
          setMessage(Strings.common.message.save_prekey);
          break;
        case SignalInitStep.SaveIdentityKey:
          setMessage(Strings.common.message.save_idkey);
          break;
        // case SignalInitStep.WaitTransactionReceipt:
        //     setProgress(Strings.common.message.wait_tx_receipt);
        //     break;
        case SignalInitStep.SaveSignalProtocolStore:
          setMessage(Strings.common.message.save_signal);
          break;
        case SignalInitStep.Completed:
          setMessage(Strings.common.message.completed);
          break;
        default:
          showError(ClientError.invalidParameterError("Invalid step"));
          break;
      }
    });
  }

  async function delay(ms = 1000) {
    await new Promise((resolve) => setTimeout(resolve, ms));
  }

  async function gotoMain() {

    await initialUserProfileIfNeeded();

    delete window.isOneClickResume;
    window.appConfig.removeTempMasterKey();
    window.appConfig.removeTempMnemonic();
    window.appConfig.removeTxHash();
    window.appConfig.removeCouponInfo();
    window.appConfig.removeTempCryptonInfo();
    window.appConfig.removeSetupFromRecovery();
    window.appConfig.isNewCreatedUser = false;
    window.appConfig.plexiMailStatus = PlexiMailStatus.Ready;
    window.wallet.removePinFromSessionStorageIfNeeded();
    window.appConfig.setupWizardState = SetupWizardState.Completed;
    await window.mailService.syncFoldersFile();
    setSetupWizardState(SetupWizardState.Completed);
    window.isUnlocked = true;
  }

  async function initialSignalContextAndBackupWalletIfNeeded() {
    if (window.wallet && window.wallet.asDefaultWallet) {
      try {
        setMessage(Strings.common.message.prepare_env);
        const isBackup = await window.wallet.isBackup();
        if (isBackup) {
          await initialSignalContext();
        } else {
          if (window.appConfig.mailAddressNeedToBeVerified) {
            setMessage(Strings.common.message.backup_wallet);
            await window.wallet.backupWalletSilently();
            await initialSignalContext();
          } else {
            setMessage(Strings.common.message.backup_wallet);
            await window.wallet.backupWalletSilently();
            await initialSignalContext();
          }
        }
      } catch (e) {
        console.error(e);
        throw e;
      }
    } else {
      await initialSignalContext();
    }
  }

  async function initialUserProfileIfNeeded() {
    const userProfile = await window.plexiMailService.getUserProfile(false);
    if (userProfile) {
      const mode = userProfile.mode;
      if (!mode){
        userProfile.mode = localStorage.getItem('app.payment-env') || 'prod';
        await window.plexiMailService.saveUserProfile("x", "y", userProfile)
      } else {
        if (mode !== localStorage.getItem('app.payment-env')) {
          localStorage.setItem('app.payment-env', userProfile.mode);
        }
      }
    } else {
      const defaultProfile = {country: "", customerId:"", subscriptionId: "", subscriptionStatus: "", data: "", isTrail: true, mode: localStorage.getItem('app.payment-env') || 'prod'};
      await window.plexiMailService.saveUserProfile("x", "y", defaultProfile)      
    }
  }

  async function initialPlexiMail() {
    if (
      window.appConfig.setupWizardState === SetupWizardState.SelectSetupMethod
    ) {
      if (
        window.appConfig.plexiMailStatus === PlexiMailStatus.WaitForRecovery ||
        window.appConfig.plexiMailStatus ===
          PlexiMailStatus.WaitForOneClickRecovery
      ) {
        try {
          setInitializing(true);
          setMessage(Strings.common.message.acquire_storage);
          await setWeb3StorageProvider();
          await assignStorage();
          setMessage(Strings.common.message.config_storage);
          await configWeb3Storage();
        } catch (e) {
          console.error(e);
          let errorMessage = e.msg || e.message || e.toString();
          setError(errorMessage);
          failedDisclosure.onOpen();
          setInitializing(false);
          return;
        } finally {
          // setInitializing(false);
        }

        await initialPlexiMail();
      } else {
        showError("Invalid PlexiMail Status");
      }
    } else if (
      window.appConfig.setupWizardState ===
        SetupWizardState.ConfigWeb3Storage ||
      window.appConfig.setupWizardState === SetupWizardState.RestoreWeb3Storage
    ) {
      if (
        window.appConfig.plexiMailStatus === PlexiMailStatus.WaitForRecovery ||
        window.appConfig.plexiMailStatus === PlexiMailStatus.WaitForNew
      ) {
        try {
          setInitializing(true);
          // setMessage(Strings.common.message.create_wallet);

          // await delay(2000);
          setMessage(Strings.common.message.acquire_storage);
          await setWeb3StorageProvider();
          await assignStorage();
          setMessage(Strings.common.message.config_storage);
          await configWeb3Storage();
        } catch (e) {
          console.error(e);
          let errorMessage = e.msg || e.message || e.toString();
          setError(errorMessage);
          failedDisclosure.onOpen();
          setInitializing(false);
          return;
        } finally {
          // setInitializing(false);
        }

        await initialPlexiMail();
      } else {
        showError("Invalid PlexiMail Status");
      }
    } else if (
      window.appConfig.setupWizardState === SetupWizardState.ConfigSignal
    ) {
      try {
        setInitializing(true);
        setMessage(Strings.common.message.initial_signal);
        await initialSignalContextAndBackupWalletIfNeeded();
        setMessage(Strings.common.message.completed_initialization);
        await gotoMain();
      } catch (e) {
        console.error(e);

        await window.mailService.resetSignalServiceFor(selectedAccount || window.appConfig.recentActiveAccount);

        try {
          await window.plexiMailService.closeAccount();
        } catch (e) {
          console.error(e);
          showError(e);
        } finally {
        }

        let errorMessage = e.msg || e.message || e.toString();
        setError(errorMessage);
        failedDisclosure.onOpen();
        setInitializing(false);
      } finally {
        // setInitializing(false);
      }
    }
  }

  return (
    <Box
      position={"relative"}
      height={"100vh"}
      width={"full"}
      overflow={"hidden"}
    >
      {isUnsupportedBrowser && (
        <UnsupportedModal disclosure={welcomeDisclosure} />
      )}

            <InternetIdentityAuthAlert onCompleted={(disabled) => {
              icpAuthTask && icpAuthTask.resolve(disabled);
            }} disclosure={icpAuthDisclosure} />

      <InitializationFailedAlert
        message={error}
        disclosure={failedDisclosure}
        onCompleted={(retry) => {
          if (retry) {
            initialPlexiMail()
              .then(() => {})
              .catch((e) => {
                console.error(e);
              });
          } else {
            reset();
          }
        }}
      />
      <Flex 
        padding={4}
        lineHeight={"100px"}
        zIndex={100000}
        position={"absolute"}
        justifyContent={"flex-end"}
        top={0}
        width={"full"}
        height={"100px"}
        >
        <Select
          value={language}
          maxWidth={"150px"}
          isDisabled={isInitializing}
          disabled={isInitializing}
          onChange={(e) => {
            setLanguage(e.target.value);
            localStorage.setItem("language", e.target.value);
            window.location.reload();
          }}
          fontSize={"sm"}
        >
          <option value="en">English</option>
          <option value="es">Español</option>
          <option value="zh">中文</option>
        </Select>

        <Link ml={4} href={HELP_DOC_URL} target="_blank">
          {Strings.home.help}
        </Link>
      </Flex>

      
      {!isInitializing &&

      <Box
        position={"relative"}
        height={"100vh"}
        width={"full"}
        overflow={"hidden"}
      >
        <Box
          height={"6xl"}
          position="relative"
          backgroundPosition="center"
          backgroundRepeat="no-repeat"
          backgroundSize="auto"
          backgroundImage={`url(/bg.jpg)`}
        >
          <Container size="container.lg" padding={0} height="600px" position="relative">
            <Flex justifyContent={"space-between"} 
              w={"100%"}
              // maxW={"lg"}
              position="absolute"
              top="50%"
              // backgroundColor={"rgba(255, 255, 255, 0.4)"}
              // backgroundColor={"blue"}
              borderRadius={10}
              //padding={{ base: 4, md: 4 }}
              transform="translate(0, -50%)">
                <Stack
                  spacing={6}
                  flex={1}
                  backgroundColor={"rgba(255, 255, 255, 0.5)"}
                  borderRadius={10}
                  padding={{ base: 4, md: 4 }}
                >
                  <Heading fontSize={{ base: "2xl", md: "3xl", lg: "4xl" }}>
                    {intros[appType].title}
                  </Heading>
                  <Text fontSize={{ base: "sm", lg: "sm" }}>
                    {intros[appType].text}
                  </Text>
                  <OrderedList fontSize={{ base: "sm", lg: "sm" }}>
                    {intros[appType].steps.map((text, idx) => {
                      return (<ListItem key={`setup-steps-${idx}`}>
                      {text}
                    </ListItem>)
                    })}
                  </OrderedList>

                  <Text fontSize={{ base: "sm", lg: "sm" }}>
                    {intros[appType].text2}
                  </Text>
                </Stack>
                <Center>
              <Button 
                isLoading={isInitializing && action === HomeScreenAction.Enter} 
                colorScheme="green" 
                minW={"100px"} 
                height={"100px"} 
                fontSize={"48px"} 
                ml={4} 
                onClick={async () => {
                  setAction(HomeScreenAction.Enter);
                  await connectClicked()
                }}>GO</Button>
              </Center>
            </Flex>
            {/* <HStack 
              w={"100%"}
              // maxW={"lg"}
              position="absolute"
              top="50%"
              backgroundColor={"rgba(255, 255, 255, 0.4)"}
              borderRadius={10}
              //padding={{ base: 4, md: 4 }}
              transform="translate(0, -50%)">
              <Text>asdasdas</Text>
              <Button>GO</Button>
            </HStack> */}
          </Container>
        </Box>
      </Box>
      }


      {isInitializing &&
      <Box
        position={"relative"}
        height={"100vh"}
        width={"full"}
        overflow={"hidden"}
      >
        {/* CSS files for react-slick */}
        <link
          rel="stylesheet"
          type="text/css"
          href="https://cdnjs.cloudflare.com/ajax/libs/slick-carousel/1.6.0/slick.min.css"
        />
        <link
          rel="stylesheet"
          type="text/css"
          href="https://cdnjs.cloudflare.com/ajax/libs/slick-carousel/1.6.0/slick-theme.min.css"
        />
        {/* Left Icon */}
        <IconButton
          aria-label="left-arrow"
          variant="ghost"
          position="absolute"
          left={side}
          top={top}
          transform={"translate(0%, -50%)"}
          zIndex={2}
          onClick={() => slider?.slickPrev()}
          color={"white"}
          _hover={{
            backgroundColor: "rgba(0, 0, 0, 0.4)"
          }}
        >
          <BiLeftArrowAlt size="40px" />
        </IconButton>
        {/* Right Icon */}
        <IconButton
          aria-label="right-arrow"
          variant="ghost"
          position="absolute"
          right={side}
          top={top}
          transform={"translate(0%, -50%)"}
          zIndex={2}
          onClick={() => slider?.slickNext()}
          color={"white"}
          _hover={{
            backgroundColor: "rgba(0, 0, 0, 0.4)"
          }}
        >
          <BiRightArrowAlt size="40px" />
        </IconButton>
        {/* Slider */}
        <Slider {...settings} ref={(slider) => setSlider(slider)}>
          {cards.map((card, index) => (
            <Box
              key={index}
              height={"6xl"}
              position="relative"
              backgroundPosition="center"
              backgroundRepeat="no-repeat"
              backgroundSize="cover"
              backgroundImage={`url(${card.image})`}
            >
              {/* This is the block you need to change, to customize the caption */}
              <Container size="container.lg" height="600px" position="relative">
                <Stack
                  spacing={6}
                  w={"full"}
                  maxW={"lg"}
                  position="absolute"
                  top="50%"
                  backgroundColor={"rgba(255, 255, 255, 0.5)"}
                  borderRadius={10}
                  padding={{ base: 4, md: 4 }}
                  transform="translate(0, -50%)"
                >
                  <Heading fontSize={{ base: "3xl", md: "4xl", lg: "5xl" }}>
                    {card.title}
                  </Heading>
                  <Text fontSize={{ base: "md", lg: "lg" }}>{card.text}</Text>
                </Stack>
              </Container>
            </Box>
          ))}
        </Slider>
      </Box>
      }

      {false && window.appConfig.setupWizardState !== SetupWizardState.Completed && 
      <VStack
        padding={4}
        lineHeight={"100px"}
        zIndex={100000}
        position={"absolute"}
        justifyContent={"center"}
        bottom={"100px"}
        width={"full"}
        height={"200px"}
      >
        <Button
          fontFamily={"heading"}
          colorScheme="purple"
          // h={"64px"}
          p={6}
          // bgGradient="linear(to-r, red.400,pink.400)"
          // color={"white"}
          // onClick={connectWallet}
          onClick={async () => {
            setAction(HomeScreenAction.Enter);
            await connectClicked()
          }}
          // isDisabled={isInvalid}
          // disabled={isInvalid}
          isLoading={isInitializing && action === HomeScreenAction.Enter}
          leftIcon={<ICPIcon width={"24px"} />}
          // _hover={{
          //   bgGradient: "linear(to-r, red.400,pink.400)",
          //   boxShadow: "xl",
          // }}
        >
          {Strings.home.signIn.button}
        </Button>
        {/* <Button
          fontFamily={"heading"}
          colorScheme="cyan"
          // h={"64px"}
          p={6}
          // bgGradient="linear(to-r, red.400,pink.400)"
          // color={"white"}
          // onClick={connectWallet}
          onClick={async () => {
            // setAction(HomeScreenAction.Enter);
            // await connectClicked()
          }}
          // isDisabled={isInvalid}
          // disabled={isInvalid}
          // isLoading={isConnecting && action === HomeScreenAction.Enter}
          leftIcon={<ICPIcon width={"24px"} />}
          // _hover={{
          //   bgGradient: "linear(to-r, red.400,pink.400)",
          //   boxShadow: "xl",
          // }}
        >
          {Strings.home.signIn.button}
        </Button> */}
      </VStack>}

      {isInitializing && (
        <Flex
          padding={4}
          lineHeight={"100px"}
          zIndex={100000}
          position={"absolute"}
          justifyContent={"center"}
          bottom={0}
          width={"full"}
          height={"100px"}
        >
          <HStack
            backgroundColor={"rgba(0, 0, 0, 0.4)"}
            padding={2}
            minWidth={"200px"}
            borderRadius={10}
          >
            <Spinner color="white" />
            {/* <Text>1/5 Creating Wallet to manage keys</Text> */}
            {/* <Text>2/5 Acquiring web3 storage to save mail data</Text> */}
            {/* <Text>3/5 Backing up wallet</Text> */}
            {/* <Text>4/5 Initializing signal protocol runtime environment</Text> */}
            <Text color={"white"} mixBlendMode={"difference"}>
              {message}
            </Text>
          </HStack>
        </Flex>
      )}
    </Box>
  );
}
